import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {CheckBoxProps} from './CheckBoxProps.interface';
import {CheckBoxSize} from './CheckBoxSize.enum';

export function CheckBox({
  checked = false,
  disabled = false,
  onChange,
  size = CheckBoxSize.Medium,
  className,
  ...props
}: CheckBoxProps) {
  return (
    <div
      className={twMerge(
        disabled && 'opacity-30',
        'relative flex w-fit-content min-w-fit items-center',
        className
      )}
      {...props}
    >
      <input
        type="checkbox"
        defaultChecked={onChange ? undefined : checked || undefined}
        checked={onChange ? checked || undefined : undefined}
        disabled={disabled}
        className="absolute h-full w-full cursor-pointer opacity-0"
        onChange={onChange}
      />
      <Icon
        className={!checked ? 'hidden' : undefined}
        type={CHECK_BOX_ON_SIZE_ICON_MAP[size]}
      />
      <Icon
        className={checked ? 'hidden' : undefined}
        type={CHECK_BOX_OFF_SIZE_ICON_MAP[size]}
      />
    </div>
  );
}

const CHECK_BOX_ON_SIZE_ICON_MAP: {[key in CheckBoxSize]: IconType} = {
  [CheckBoxSize.Small]: IconType.CheckBoxSOnStatic,
  [CheckBoxSize.Medium]: IconType.CheckBoxMOnStatic,
  [CheckBoxSize.Large]: IconType.CheckBoxLOnStatic,
  [CheckBoxSize.ContentHome]: IconType.ContentHomeCheckOn,
  [CheckBoxSize.SubTab]: IconType.TabCheckOn,
};

const CHECK_BOX_OFF_SIZE_ICON_MAP: {[key in CheckBoxSize]: IconType} = {
  [CheckBoxSize.Small]: IconType.CheckBoxSOff,
  [CheckBoxSize.Medium]: IconType.CheckBoxMOff,
  [CheckBoxSize.Large]: IconType.CheckBoxLOff,
  [CheckBoxSize.ContentHome]: IconType.ContentHomeCheckOff,
  [CheckBoxSize.SubTab]: IconType.TabCheckOff,
};
